export const enum StaffStatusEnum {
  initial = 'initial',
  confirmed = 'confirmed',
  requested = 'requested',
  deniedRequest = 'deniedRequest',
}
